import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ic_download_24px_a55cd12a3d7a772b81526ad607168d80",
  "use": "ic_download_24px_a55cd12a3d7a772b81526ad607168d80-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"ic_download_24px_a55cd12a3d7a772b81526ad607168d80\">\n    <path fill-rule=\"evenodd\" d=\"M16.806 12.703L12 17.51l-4.806-4.806.884-.884 3.297 3.297V4h1.25v11.116l3.297-3.297.884.884zM20 18.75H4V20h16v-1.25z\" clip-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol